import { Chart } from "chart.js/auto";
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { ref, createRef, Ref } from "lit/directives/ref.js";

@customElement("c-qa-count-per-partner")
export class QaCountPerPartnerWidget extends LitElement {
    static styles = css`
        :host {
            display: block;
            height: 100%;
        }
    `;

    canvas: Ref<HTMLCanvasElement> = createRef();

    async firstUpdated() {
        const data = {
            labels: [
                "FREE NOW / Intelligent Apps GmbH",
                "Stadtwerke Goch",
                "Stadtwerke Ingolstadt Energie Gm..",
                "Dortmunder Energie- und Wasserv..",
                "TankE GmbH",
                "EMOVY GmbH",
                "envia Mitteldeutsche Energie AG",
                "energiehoch3 GmbH",
                "Majorel API Mandant",
                "SWE Energie GmbH",
                "Stadtwerke Wurzburg AG",
            ],
            datasets: [
                {
                    axis: "y",
                    label: "QA Count",
                    //data: [0, 0, 80, 90, 100, 200, 250, 1200, 1500, 2000, 3000],
                    data: [
                        0, 0, 80, 90, 100, 200, 250, 1200, 1500, 2000, 3000,
                    ].reverse(),
                    fill: false,
                    backgroundColor: "rgba(132, 44, 255, 0.7)",
                    borderWidth: 1,
                },
            ],
        };
        new Chart(this.canvas.value, {
            type: "bar",
            data,
            options: {
                indexAxis: "y",
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: "QA Count per Partner",
                    },
                },
            },
        });
    }

    render() {
        return html`<canvas ${ref(this.canvas)}></canvas>`;
    }
}
